import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useCampaignByIdQuery } from "Api/Queries/Admin/useCampaignByIdQuery";
import { useParams } from "react-router";
import { appUrl } from "Utils/UrlUtils";
import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { Resources, useResource } from "Translations/Resources";
import { CampaignEditContent } from "Components/Admin/Campaigns/CampaignEditContent";
import { useSearchParams } from "Navigation/useSearchParams";

const RESOURCES = Resources.Admin.Campaigns.Messages;

export const CampaignEditPage = () => {
  const { t } = useResource();
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();

  const campaignId = id ? Number.parseInt(id, 10) : null;
  const {
    data: campaign,
    isLoading,
    isError,
  } = useCampaignByIdQuery(campaignId);

  const activeStepParam = searchParams.get("activeStep");
  const isWideStep =
    activeStepParam === "landing-page" || activeStepParam === "thank-you-page";

  if (isLoading) {
    return (
      <AuthenticatedLayout
        title={t(Resources.Pages.Titles.AdminCampaignEdit)}
        backNavigation={{
          mode: "historyStack",
          fallbackUrl: appUrl("admin-campaigns"),
        }}
      >
        <StyledPageWrapper>
          <CenteredCircularProgress />
        </StyledPageWrapper>
      </AuthenticatedLayout>
    );
  }

  if (isError || !campaign) {
    return (
      <AuthenticatedLayout
        title={t(Resources.Pages.Titles.AdminCampaignEdit)}
        backNavigation={{
          mode: "historyStack",
          fallbackUrl: appUrl("admin-campaigns"),
        }}
      >
        <StyledPageWrapper>
          <ErrorText>{t(RESOURCES.LoadCampaignsError)}</ErrorText>
        </StyledPageWrapper>
      </AuthenticatedLayout>
    );
  }

  return (
    <AuthenticatedLayout
      title={t(RESOURCES.EditCampaignTitle, { name: campaign.name })}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("admin-campaigns"),
      }}
    >
      <StyledPageWrapper $maxWidth={isWideStep ? "unset" : undefined}>
        <CampaignEditContent campaign={campaign} />
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default CampaignEditPage;
